import { Check, CircleDashed, Loader2, X } from 'lucide-react';

import { CREATION_STEP_STATUS, type CreationStepState } from '../model/types';

type CreationProgressOverlayProps = {
  steps: CreationStepState[];
  isCreating: boolean;
};

const StepIcon = ({ status }: { status: CreationStepState['status'] }) => {
  switch (status) {
    case CREATION_STEP_STATUS.PENDING:
      return <CircleDashed size={16} className="text-muted-foreground" />;
    case CREATION_STEP_STATUS.IN_PROGRESS:
      return <Loader2 size={16} className="animate-spin text-primary" />;
    case CREATION_STEP_STATUS.COMPLETED:
      return <Check size={16} className="text-green-500" />;
    case CREATION_STEP_STATUS.FAILED:
      return <X size={16} className="text-destructive" />;
  }
};

export const CreationProgressOverlay = ({
  steps,
  isCreating,
}: CreationProgressOverlayProps) => {
  if (!isCreating) return null;

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col gap-3 rounded-lg border border-border bg-background p-6 shadow-lg">
        <h3 className="text-sm font-semibold">Creating dashboard...</h3>
        <div className="flex flex-col gap-2">
          {steps.map((step) => (
            <div key={step.step} className="flex items-center gap-2">
              <StepIcon status={step.status} />
              <span className="text-xs text-muted-foreground">
                {step.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
